/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationBellOffIcon16Solid = forwardRef('NotificationBellOffIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.395.293A1 1 0 0 0 .98 1.707l2.47 2.469A4.982 4.982 0 0 0 3 6.25v3.032l-1.633 2.565A.75.75 0 0 0 2 13h10.273l1.707 1.707a1 1 0 0 0 1.415-1.414l-13-13Z" }),
        React.createElement("path", { d: "M13 6.25v2.336L6.056 1.642A5 5 0 0 1 13 6.25Z" }),
        React.createElement("path", { d: "M8 15.998A2.249 2.249 0 0 1 5.765 14h4.47A2.249 2.249 0 0 1 8 15.998Z" })));
});
